import React, { useState } from "react";
import type { FormEvent } from "react";

/**
 * Admin form for sending push notifications with custom payload fields.
 * Update the fetch URL to point to your backend/Supabase Edge Function endpoint.
 */
const SendNotification: React.FC = () => {
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [userId, setUserId] = useState("");
  const [icon, setIcon] = useState("");
  const [clickUrl, setClickUrl] = useState("");
  const [actions, setActions] = useState("");
  const [status, setStatus] = useState("");

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setStatus("Sending...");
    try {
      const payload: any = {
        title,
        body,
        user_id: userId || null,
        data: {
          ...(icon && { icon }),
          ...(clickUrl && { click_url: clickUrl }),
          ...(actions && { actions: JSON.parse(actions) })
        }
      };

      // TODO: Update this endpoint to your actual notifications API
      const res = await fetch("/api/notifications", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      if (res.ok) {
        setStatus("Notification sent!");
        setTitle("");
        setBody("");
        setUserId("");
        setIcon("");
        setClickUrl("");
        setActions("");
      } else {
        setStatus("Failed to send notification.");
      }
    } catch (err: any) {
      setStatus("Error: " + err.message);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="max-w-md p-6 mx-auto mt-8 bg-white border border-green-200 rounded-md shadow-md"
    >
      <h2 className="mb-4 text-xl font-semibold text-green-800">Send Notification</h2>
      <div className="mb-4">
        <label className="block mb-2 text-sm font-bold text-gray-700">
          Title
          <input
            value={title}
            onChange={e => setTitle(e.target.value)}
            required
            className="w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
          />
        </label>
      </div>
      <div className="mb-4">
        <label className="block mb-2 text-sm font-bold text-gray-700">
          Body
          <textarea
            value={body}
            onChange={e => setBody(e.target.value)}
            required
            className="w-full h-24 px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline" // Added h-24 for default height
          />
        </label>
      </div>
      <div className="mb-4">
        <label className="block mb-2 text-sm font-bold text-gray-700">
          User ID (optional)
          <input
            value={userId}
            onChange={e => setUserId(e.target.value)}
            className="w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
          />
        </label>
      </div>
      <div className="mb-4">
        <label className="block mb-2 text-sm font-bold text-gray-700">
          Icon URL (optional)
          <input
            value={icon}
            onChange={e => setIcon(e.target.value)}
            className="w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
          />
        </label>
      </div>
      <div className="mb-4">
        <label className="block mb-2 text-sm font-bold text-gray-700">
          Click URL (optional)
          <input
            value={clickUrl}
            onChange={e => setClickUrl(e.target.value)}
            className="w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
          />
        </label>
      </div>
      <div className="mb-6"> {/* Changed to mb-6 for slightly more space before button */}
        <label className="block mb-2 text-sm font-bold text-gray-700">
          Actions (optional, JSON array)
          <textarea
            value={actions}
            onChange={e => setActions(e.target.value)}
            placeholder='e.g. [{"action":"view","title":"View Now","url":"https://..."}]'
            className="w-full h-32 px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline" // Increased height for actions
          />
        </label>
      </div>
      <button
        type="submit"
        className="px-4 py-2 font-bold text-white bg-green-600 rounded hover:bg-green-700 focus:outline-none focus:shadow-outline"
      >
        Send
      </button>
      <div
        className={`mt-4 text-sm ${status.startsWith("Error") ? "text-red-500" : "text-green-500"}`}
      >
        {status}
      </div>
    </form>
  );
};

export default SendNotification;